import { Tooltip } from '@/design-system';
import { getColorByString } from '@/utils/get-color-by-string';
import { cn } from '@/utils/tailwind';

export const ProfileCircle = ({
  name,
  backupIcon,
  className,
  showTooltip = false,
  manualColor,
  active,
}: {
  name: string;
  backupIcon?: React.ReactNode;
  className?: string;
  showTooltip?: boolean;
  manualColor?: string;
  active?: boolean;
}) => {
  // Reuse the feedback color generator to generate colors for the profile labels
  const color = manualColor ?? getColorByString(name);
  const gradientStyle = active
    ? {}
    : {
        backgroundImage: `linear-gradient(to bottom right, ${color}, #aaaaaa)`,
      };

  return (
    <Tooltip title={showTooltip ? name : undefined}>
      <div
        className={cn(
          'inline-flex h-6 w-6 shrink-0 flex-col items-center justify-center rounded-full text-sm uppercase',
          active
            ? ' rounded-[40px] bg-gradient-to-br from-brand-green-500 to-cyan-400'
            : '',
          className
        )}
        style={gradientStyle}
      >
        <div className="cursor-default font-medium text-white text-opacity-90">
          {name.length > 0 ? name.charAt(0) : backupIcon}
        </div>
      </div>
    </Tooltip>
  );
};
